var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplogieLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242.83 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00909b;}.cls-2{fill:#00bc96;}.cls-3{fill:#134873;}.cls-4{fill:#12beda;}.cls-5{fill:#008f70;}.cls-6{isolation:isolate;}.cls-7{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "applogie_logo_horizontal_blue-bkgd") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Arrangement_full-color",
    "data-name": "Logo Arrangement full-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "applogie_logo_horizontal_blue-bkgd",
    "data-name": "applogie logo horizontal blue-bkgd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-_-full-color",
    "data-name": "logo-/-full-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5",
    className: "cls-1",
    points: "36 0 18 0 27 18 36 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5-Copy-4",
    className: "cls-2",
    points: "54 36 36 36 45 54 54 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5-Copy-2",
    className: "cls-1",
    points: "18 36 0 36 9 54 18 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    className: "cls-3",
    points: "18 0 27 18 18 36 0 36 18 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1-Copy",
    className: "cls-4",
    points: "36 36 27 54 9 54 18 36 36 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1-2",
    "data-name": "Page-1",
    className: "cls-5",
    points: "27 18 36 36 54 36 45 18 27 18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "applogie_wordmark_white",
    "data-name": "applogie wordmark white",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96,33.86H88.41L87.36,36H83.13l7.75-15.6h2.83L101.18,36H97Zm-1.46-3-2.33-5-2.21,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M122.08,26.54v.36a6.17,6.17,0,0,1-6.14,5.78h-3.22V36h-3.82V20.4h7.58a5.81,5.81,0,0,1,5.59,5.79Zm-3.86,0a2.32,2.32,0,0,0-2.28-2.33h-3.22v4.66h3.17A2.32,2.32,0,0,0,118.22,26.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.23,26.54v.36a6.17,6.17,0,0,1-6.14,5.78h-3.22V36h-3.82V20.4h7.58a5.82,5.82,0,0,1,5.59,5.79Zm-3.86,0a2.32,2.32,0,0,0-2.28-2.33h-3.22v4.66H137A2.32,2.32,0,0,0,139.36,26.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M164.59,32.26V36H151.08V20.4h3.74V32.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M188,28.22A8.22,8.22,0,1,1,179.76,20,8.21,8.21,0,0,1,188,28.22Zm-3.6,0a4.62,4.62,0,1,0-4.61,4.61A4.63,4.63,0,0,0,184.36,28.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M211.1,33.07h0a8.23,8.23,0,1,1-6.6-13.13,7.7,7.7,0,0,1,6.43,3.17l-2.86,1.82a4.88,4.88,0,0,0-3.58-1.39,4.62,4.62,0,1,0,3.34,7.82V29.74h-4.73v-3h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M222.67,20.4V36h-3.74V20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M234.83,23.76v2.78h6.31v3.34h-6.31v2.78h8V36H231.09V20.4h11.74v3.36Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplogieLogo);
export default __webpack_public_path__ + "static/media/applogie-logo.0b802d4a853e41ac1c31fd150ec74b70.svg";
export { ForwardRef as ReactComponent };